<agpr-dialog-container
    [id]="id + '.dataSelectDialog'"
    [heading]="dialogHeader"
    (close)="doHide()"
    styleClass="agpr-dataSelectDialog"
>
    <div class="agpr-dataSelectDialog-container">
        <div class="agpr-dataSelectDialogMessage">
            {{ dialogMessage | localize }}
        </div>
        <div class="agpr-dataSelectDialogContent">
            <div
                class="agpr-dataSelectDialogContent-column agpr-dataSelectDialog-availableItems"
            >
                <span class="agpr-dataSelectDialogContent-columnHeader">
                    {{ leftColumnHeader | localize }}
                </span>
                <div class="agpr-dataSelectDialogContent-column--thing">
                    <agpr-scroll-panel
                        *ngIf="!filterDataType"
                        class="agpr-dataSelectDialogContent-panel"
                    >
                        <agpr-tree-list
                            class="agpr-dataSelectDialogContent-treelist"
                            [hideParentCheckbox]="false"
                            [items]="availableItems"
                            [(selection)]="selectedItems"
                            styleClass="agpr-dataSelectDialog-tree"
                            [propagateSelectionUp]="propagateSelection"
                            [propagateSelectionDown]="propagateSelection"
                            (selectionChange)="selectionChange($event)"
                            (nodeSelect)="itemSelected($event)"
                            (nodeUnselect)="itemUnselected($event)"
                            (nodeExpand)="nodeExpanded($event)"
                            (nodeCollapse)="nodeCollapsed($event)"
                            [lockMessage]="lockMessage"
                        ></agpr-tree-list>
                    </agpr-scroll-panel>
                    <ng-container *ngIf="filterDataType">
                        <div class="agpr-dataSelectDialogContent-filterSearch">
                            <agpr-text-input
                                [id]="id + '.quickFilter'"
                                [(ngModel)]="filterString"
                                (ngModelChange)="filterItems()"
                                ariaLabel="Common.dialog.dataSelect.filterPlaceholder"
                                placeholder="Common.dialog.dataSelect.filterPlaceholder"
                                [initialFocus]="true"
                            ></agpr-text-input>
                            <span class="fa-regular fa-duotone fa-magnifying-glass agpr-dataSelectDialogContent-filterSearch-filterIcon"></span>
                        </div>
                        <agpr-scroll-panel class="agpr-dataSelectDialogContent-panel">
                            <agpr-tree-list
                                class="agpr-dataSelectDialogContent-treelist"
                                [hideParentCheckbox]="false"
                                [items]="filteredAvailableItems"
                                [(selection)]="selectedItems"
                                styleClass="agpr-dataSelectDialog-tree"
                                (selectionChange)="selectionChange($event)"
                                (nodeSelect)="itemSelected($event)"
                                (nodeUnselect)="itemUnselected($event)"
                                (nodeExpand)="nodeExpanded($event)"
                                (nodeCollapse)="nodeCollapsed($event)"
                                [lockMessage]="lockMessage"
                                [templateDataType]="filterDataType"
                                [filterString]="filterString.length > 2 ? [filterString] : []"
                            ></agpr-tree-list>
                        </agpr-scroll-panel>
                    </ng-container>
                </div>
            </div>
            <div
                class="agpr-dataSelectDialogContent-column agpr-dataSelectDialog-selectedItems"
            >
                <span class="agpr-dataSelectDialogContent-columnHeader">
                    {{ rightColumnHeader | localize }}
                </span>
                <div class="agpr-dataSelectDialogContent-column--thing">
                    <agpr-scroll-panel>
                        <ul class="agpr-dataSelectDialogContent-columnList">
                            <li
                                *ngFor="let type of selectedItemTypes; index as i"
                                class="agpr-dataSelectDialogContent-columnListItem"
                            >
                                <span class="agpr-dataSelectDialogContent-columnListItemType">
                                    {{ selectedItemTypesMap.get(type) | localize }}
                                </span>
                                <ul
                                    [id]="'selectedData_' + i"
                                    class="agpr-dataSelectDialogContent-columnListItem-container"
                                    agprListKeyboardNavigation
                                    listOrientation="horizontal"
                                    [focusOnChild]="true"
                                    [list]="selectedItemsToDisplay"
                                >
                                    <ng-container *ngFor="let item of selectedItemsToDisplay">
                                        <li
                                            *ngIf="item.type === type || item.data.type === type"
                                            class="agpr-chip"
                                        >
                                            <span class="agpr-chip-label">
                                                {{ item.label }}
                                            </span>
                                            <agpr-button
                                                class="agpr-chip-button"
                                                [style]="buttonTypes.icon"
                                                icon="agpr-i-close"
                                                tooltip="Common.forms.chips.delete"
                                                tooltipPosition="top"
                                                (click)="removeItem(item)"
                                            ></agpr-button>
                                        </li>
                                    </ng-container>
                                </ul>
                            </li>
                        </ul>
                    </agpr-scroll-panel>
                </div>
            </div>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '.dataSelectDialog.cancel'"
            label="cancel"
            [style]="buttonTypes.secondary"
            (click)="doHide()"
        ></agpr-button>
        <agpr-button
            [id]="id + '.dataSelectDialog.clear'"
            label="Monitoring.result.reset"
            [style]="buttonTypes.secondary"
            (click)="reset()"
    ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '.dataSelectDialog.ok'"
            label="Monitoring.result.applySelected"
            [style]="buttonTypes.primary"
            (click)="applySelected()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
